export default "__VITE_ASSET__d67d8114__"